import {
  LOG_LEVELS,
  loggerHelper,
  updateAnonymousId,
} from 'utils/logger/loggerHelper';
import { IS_PRELOAD } from 'utils/queryParamHelpers';
import { createAnonymousId } from 'utils/segment';

export async function initSegment() {
  if (IS_PRELOAD) return Promise.resolve();

  return Promise.race([segmentReady, segmentFallback]).then(anonymousId => {
    let anonId = anonymousId;

    if (!anonymousId) {
      anonId = createAnonymousId();

      loggerHelper({
        level: LOG_LEVELS.INFO,
        message:
          'Segment analytics.js not ready in time, generating our own anonynmous ID.',
      });
    }

    updateAnonymousId(anonId);

    return anonId; // Use final anonymousId to make initial fetchAndStoreVariants call
  });
}

const segmentReady = new Promise(resolve => {
  if (window.analytics) {
    analytics.ready(() => analyticsReady(resolve));
  }
});

const segmentFallback = new Promise(resolve => {
  if (IS_PRELOAD) return resolve();

  setTimeout(resolve, 1000);
});

const analyticsReady = resolve => {
  resolve(analytics.user().anonymousId());
};
